import { render, staticRenderFns } from "./SettingCredit.vue?vue&type=template&id=20476294&"
import script from "./SettingCredit.vue?vue&type=script&lang=js&"
export * from "./SettingCredit.vue?vue&type=script&lang=js&"
import style0 from "./SettingCredit.vue?vue&type=style&index=0&id=20476294&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports